//* 组件库
import { utility } from "various-ui";
import type { UiCarouselMultipleView } from "various-ui";
//* 全局属性
import type { NavigateToRoute } from "@/utils/router/src/types";
//* 组件属性
import type { HomeData } from "./types";
import { useOptions } from "./options";

export const useComposable = (data: Ref<HomeData>) => {
    //* 配置
    const options = useOptions(data);

    //* 静态属性
    const variable: { observer?: ResizeObserver } = {};

    //* 响应式变量
    const refs = {
        keyword: ref<string>(""), //* 搜索关键词
        current: ref<number>(0), //* 推荐工具轮播当前页
        pagination: ref<number>(1), //* 推荐工具轮播分页
    };

    //* 节点
    const nodes = {
        statistic: ref<HTMLDivElement[]>([]),
        carousel: ref<InstanceType<typeof UiCarouselMultipleView>>(), //* 推荐工具轮播
    };

    //* 函数列表
    const methods = {
        //* 搜索
        search: (context: string, mode: string, id?: string) => {
            //* 数据初始化
            const keyword = context?.trim();
            //* 检测是否存在关键词
            if (!keyword) return;
            //* 有返回id和类型 直接跳转到详情页
            if (!options.type[mode]) open(routerResolve({ name: "Search", query: { keyword: keyword, date: new Date().getTime() } }).href as string);
            else {
                const config = { mode: options.type[mode], route: {} as string | NavigateToRoute };
                if (!id) config.route = { name: "Search" + config.mode, query: { keyword: keyword, date: new Date().getTime() } };
                else {
                    if (config.mode == "Tool") config.route = id;
                    else {
                        config.route = { name: config.mode, params: { id: id } };
                    }
                }

                open(routerResolve(config.route).href as string);
            }
        },

        //* 路由
        route: (data: any) => {
            if (data.search_type == "custom") return data.link;
            else {
                return { name: utility.upperFirst(data.search_type), params: { id: data.value_id } };
            }
        },

        //* 切换推荐工具分页
        switch: (index: number) => {
            if (refs.current.value < index) {
                nodes.carousel.value?.switchNext();
            } else if (refs.current.value > index) {
                nodes.carousel.value?.switchBack();
            }
            refs.current.value = index;
        },

        //* 宽度改变函数
        resize: () => {
            //* 统计数据固定宽度
            nodes.statistic.value.forEach((node, key) => {
                if (options.statistics[key].unit) {
                    node.style.width = node.children[0].clientWidth + 2 + "px";
                } else {
                    node.style.width = node.children[0].clientWidth + 12 + "px";
                }
            });

            //* 推荐工具分页
            refs.pagination.value = Math.ceil(options.tools.length / (document.body?.clientWidth < 1520 ? 4 : 5));
        },
    };

    return { variable, options, refs, nodes, methods };
};
